export class AsyncQueue {
    constructor({ concurrency = 10 } = {}) {
        this.mutableQueue = [];
        this.inflight = new Map();
        this.mutableRunning = 0;
        this.concurrency = concurrency;
    }
    async execute(key, execute) {
        const existing = this.inflight.get(key);
        if (existing !== undefined) {
            return existing;
        }
        const promise = new Promise((resolve, reject) => {
            this.mutableQueue.push({
                key,
                execute,
                resolve,
                reject,
            });
        });
        this.inflight.set(key, promise);
        this.advance();
        return promise;
    }
    advance() {
        if (this.mutableRunning >= this.concurrency) {
            return;
        }
        const entry = this.mutableQueue.shift();
        if (entry !== undefined) {
            const next = () => {
                this.inflight.delete(entry.key);
                this.mutableRunning -= 1;
                this.advance();
            };
            this.mutableRunning += 1;
            entry
                .execute()
                .then(async (result) => {
                entry.resolve(result);
                next();
            })
                .catch((error) => {
                entry.reject(error);
                next();
            });
        }
    }
}

//# sourceMappingURL=AsyncQueue.js.map
